import { render, staticRenderFns } from "./screenSwitcher.vue?vue&type=template&id=769278e0"
import script from "./screenSwitcher.vue?vue&type=script&lang=js"
export * from "./screenSwitcher.vue?vue&type=script&lang=js"
import style0 from "./screenSwitcher.vue?vue&type=style&index=0&id=769278e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports